const state = {
    queue: [],
}

const getters = {
}

const mutations = {
    push: (state, item) => {
        let flash = JSON.parse(JSON.stringify(item))
        flash.color = flash.color || 'green'
        if (!flash.life) {
            switch (flash.color) {
                case 'red':
                    flash.life = 50
                    break
                default:
                    flash.life = 50
                    break
            }
        }
        for (let i = state.queue.length - 1; i >= 0; i--) {
            if (flash.color === state.queue[i].color && flash.text === state.queue[i].text) {
                state.queue[i].life = flash.life
                return
            }
        }
        state.queue.push(flash)
    },
    process: (state, tick) => {
        if (!tick) {
            tick = 1
        }
        for (let i = state.queue.length - 1; i >= 0; i--) {
            state.queue[i].life -= tick
            if (state.queue[i].life <= 0) {
                state.queue.splice(i, 1)
            }
        }
    },
}

const actions = {
    async push (context, { color, text, life, }) {
        context.commit('push', { color: color, text: text, life: life, })
    },
    async process (context, tick = 1) {
        context.commit('process', tick)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


